import * as tslib_1 from "tslib";
import { ErrorHandler } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessFinderService } from './business-finder.service';
import { ServiceRepairResult } from '../models/service-repair-result.model';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * HTTP service for the Service/Repair Finder. Calls the AirportsAPI `~/service-repairs` endpoint. Category
 * facet filtering (Airframe / Avionics / Powerplant / ...) is applied client-side in
 * {@link SearchPageComponent}; this service performs only the location/state/keyword query.
 */
var ServiceRepairsService = /** @class */ (function (_super) {
    tslib_1.__extends(ServiceRepairsService, _super);
    function ServiceRepairsService(http, errorHandler) {
        var _this = _super.call(this, http, errorHandler) || this;
        _this.endpoint = 'service-repairs';
        return _this;
    }
    ServiceRepairsService.prototype.parse = function (data) {
        return ServiceRepairResult.parse(data);
    };
    ServiceRepairsService.prototype.getServiceRepairsByLatLon = function (latlon, radius) {
        return this.getByLatLon(latlon, radius);
    };
    ServiceRepairsService.prototype.getServiceRepairsByBoundingBox = function (bounds) {
        return this.getByBoundingBox(bounds);
    };
    ServiceRepairsService.prototype.getServiceRepairsByState = function (state) {
        return this.getByState(state);
    };
    ServiceRepairsService.prototype.getServiceRepairsBySearchTerm = function (term) {
        return this.getBySearchTerm(term);
    };
    ServiceRepairsService.ngInjectableDef = i0.defineInjectable({ factory: function ServiceRepairsService_Factory() { return new ServiceRepairsService(i0.inject(i1.HttpClient), i0.inject(i0.ErrorHandler)); }, token: ServiceRepairsService, providedIn: "root" });
    return ServiceRepairsService;
}(BusinessFinderService));
export { ServiceRepairsService };
